import React from 'react';
import {
  Col,
  Grid,
  Row,
} from 'react-bootstrap';
import languagesPropType from '../languagesPropType.js';
import styles from './styles.css';
import translate from './translate.js';

const NoRecovery = ({
  language,
}) => (
  <Grid
    className={styles.grid}
    fluid
  >
    <Row style={{textAlign: 'center'}}>
      <Col xs={12}>
        <span style={{fontSize: '18px'}}>{translate('contactAdmin', language)}</span>
      </Col>
    </Row>

    <Row style={{marginTop: '20px', textAlign: 'center'}}>
      <Col xs={12}>
        <div style={{fontSize: '16px', fontWeight: 400}}>{translate('contactAdminDescription', language)}</div>
      </Col>
    </Row>
  </Grid>
);

NoRecovery.defaultProps = {
  language: languagesPropType.defaultProp,
};

NoRecovery.propTypes = {
  language: languagesPropType.propType,
};

export default NoRecovery;
